import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from 'services/supabaseClient';
import SectionCard from 'components/SectionCard';
import FooterCompact from 'components/FooterCompact'; // ✅ add

function UpdatePassword() {
  const [authEmail, setAuthEmail] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [emailChangeRequested, setEmailChangeRequested] = useState(false);
  const navigate = useNavigate();

  const [isRecovery, setIsRecovery] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.replace('#', '?'));
    if (params.get('access_token') || params.get('type') === 'recovery') {
      setIsRecovery(true);
    }

    const init = async () => {
      const { data: { session } } = await supabase.auth.getSession();

      if (session?.user?.email) {
        setAuthEmail(session.user.email);
        setNewEmail(session.user.email);
      }
    };
    init();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (password !== confirmPassword) {
      return setError('Passwords do not match.');
    }

    if (!isRecovery) {
      if (!currentPassword) return setError('Current password is required.');

      const signIn = await supabase.auth.signInWithPassword({
        email: authEmail,
        password: currentPassword,
      });
      if (signIn.error) {
        return setError('Authentication failed. Please check your current password.');
      }

      const updates = {};
      if (newEmail !== authEmail) updates.email = newEmail;
      if (password) updates.password = password;

      const { error } = await supabase.auth.updateUser(updates);
      if (error) return setError('Error: ' + error.message);

      if (updates.email) {
        setEmailChangeRequested(true);
        setMessage(
          "Check both inboxes to confirm the change. You won't be able to access your profile until this is complete."
        );
      } else {
        setMessage('Account updated successfully.');
        setTimeout(() => navigate('/user-profile'), 1500);
      }
    } else {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) return setError('Error resetting password: ' + error.message);

      setMessage('Password reset successfully. You may now log in.');
      setTimeout(() => navigate('/'), 1500);
    }
  };

  const inputCls =
    "w-full px-4 py-2 rounded-md border border-app input-app focus:outline-none focus-visible:ring-app";
  const linkCls =
    'text-brand1 underline underline-offset-2 hover:text-brand1-dark dark:text-brand1-light';

  return (
    <div className="bg-app text-app bg-surface min-h-screen flex flex-col">
      {/* Main content */}
      <div className="flex-1 p-6 flex items-start justify-center">
        <div className="w-full max-w-lg">
          <h1 className="text-2xl font-semibold">
            {isRecovery ? 'Reset Password' : 'Change Email or Password'}
          </h1>

          <SectionCard className="mt-4">
            <form onSubmit={handleSubmit} className="space-y-4">
              {!isRecovery && (
                <>
                  <div>
                    <label className="block mb-1 font-medium">Current Email</label>
                    <input
                      type="email"
                      value={authEmail}
                      disabled
                      className={`${inputCls} disabled:opacity-60`}
                    />
                  </div>
                  <div>
                    <label className="block mb-1 font-medium">New Email</label>
                    <input
                      type="email"
                      value={newEmail}
                      onChange={(e) => setNewEmail(e.target.value)}
                      className={inputCls}
                      required
                    />
                  </div>
                  <div>
                    <label className="block mb-1 font-medium">Current Password</label>
                    <input
                      type="password"
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                      className={inputCls}
                      required
                    />
                  </div>
                </>
              )}

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block mb-1 font-medium">Set Password</label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={inputCls}
                    required
                  />
                </div>
                <div>
                  <label className="block mb-1 font-medium">Confirm Password</label>
                  <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className={inputCls}
                    required
                  />
                </div>
              </div>

              {!emailChangeRequested && (
                <>
                  <button type="submit" className="btn btn-primary w-full">
                    {isRecovery ? 'Reset Password' : 'Update Account'}
                  </button>
                  {!isRecovery && (
                    <button
                      type="button"
                      onClick={() => navigate('/user-profile')}
                      className={`w-full mt-2 ${linkCls}`}
                    >
                      Cancel
                    </button>
                  )}
                </>
              )}
            </form>

            {error && <p className="mt-4 text-center text-sm text-red-600">{error}</p>}
            {message && (
              <div className="mt-4 panel-subtle p-3 rounded text-sm text-app text-center">
                {message}
              </div>
            )}
          </SectionCard>
        </div>
      </div>

      {/* ✅ Compact footer */}
      <FooterCompact />
    </div>
  );
}

export default UpdatePassword;
